export const allowedCharsEng = 'ABEKMHOPCTYXabekmhopctyx'
export const allowedCharsRu = 'АВЕКМНОРСТУХавекмнорстух'
export const allowedChars = allowedCharsRu + allowedCharsEng

export const licencePlateRegExp = new RegExp(`([${allowedChars}]\\d{3}[${allowedChars}]{2}(\\d\\d|\\d\\d\\d))`)
export const licencePlateNumber = (v: string): boolean => !v || licencePlateRegExp.test(v)
export const licencePlateRegion = (v: string): boolean => v ? !(v.substring(6).startsWith('00')) : false
export const validLicencePlate = (v: string) => !v || (licencePlateNumber(v) && licencePlateRegion(v))

// regexpRuDoc [2 числа] [2 буквы или 2 числа] [6 чисел] - используется для типовых документов, например ву и стс
export const regexpRuDoc = new RegExp(`(\\d{2}(?:\\d{2}|[${allowedChars}]{2})\\d{6})`)
export const validCtc = (v: string) => !v || regexpRuDoc.test(v)
